import DocxTemplate from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import JSZip from 'jszip';
import axios from 'axios'
// import toPdf from 'custom-soffice-to-pdf'
// import toPdf  from "office-to-pdf"
var DocxMerger = require('docx-merger');
import flat from "flat";
import {saveAs} from "file-saver";
import {getGradeFullName, getPupilFullName} from "@/utils/parseObj";

const nullGetter = (part, scopeManager) => {
    return "";
}

const prepareObj = (object, userName, gradeId, dateHebrew, reportName, oldReportToPrint) => {
    console.log("object",object)
    if (object?.ratedScores){
        const ratedScores = Object?.keys(object?.ratedScores)
        ratedScores?.forEach(key => {
            const score = object.ratedScores[key]?.score
            object.ratedScores[key][`${score}`] = '✔️'
        })
    }

    object.old = oldReportToPrint
    if (object?.old?.ratedScores){
        const ratedScores = Object?.keys(object.old.ratedScores)
        ratedScores?.forEach(key => {
            const score = object.old.ratedScores[key]?.score
            object.old.ratedScores[key][`${score}`] = '✔️'
        })
    }

    object.p = object?.presenceScores
    object.b = object?.behaviorScores
    object.t = object?.topicsScores
    object.r = object?.ratedScores
    console.log(object)
    const flatObj = flat(object)
    const prefixes = ["p.", "b.", "t.", "r."];
    const suffixMap = {
        "description": "d",
        "score": "s"
    };

    for (const key of Object.keys(flatObj)) {
        if (prefixes.some(prefix => key.startsWith(prefix))) {
            let newKey = key;

            for (const [suffix, replacement] of Object.entries(suffixMap)) {
                if (key.endsWith(suffix)) {
                    newKey = key.replace(suffix, replacement);
                    flatObj[newKey]= flatObj[key]
                    break;
                }
            }

            // newObj[newKey] = flatObj[key];
        } else {
            // newObj[key] = flatObj[key]; // אם לא מתאים, משאירים אותו כמו שהוא
        }
    }



    const gradeName = getGradeFullName(gradeId)
    flatObj.grade = gradeName.split(" ")[0]
    flatObj.nameReport = reportName
    flatObj.pupil = getPupilFullName(flatObj.pupil)
    flatObj.teacher = userName
    flatObj.date = dateHebrew
    return flatObj;
}
function getBinaryContentWithRedirectSupport(url, callback) {
    axios.get(`/download/file?url=${encodeURIComponent(url)}`, {
        responseType: 'arraybuffer', // חשוב – אחרת תקבל טקסט
        maxRedirects: 5              // ברירת מחדל היא 5, אפשר גם לשנות
    })

        .then(response => {
            console.log(response.data)
            callback(null, response.data);
        })
        .catch(error => {
            callback(error, null);
        });
}

export const printReports = (objects, userName, gradeId, dateHebrew, oneFile = false, reportName, reportStampName, oldReportToPrints, errorBlock) => {
    try {
        let fileName
            if (reportStampName.startsWith("http")){
                fileName = reportStampName
            } else {

                fileName = `https://docs.google.com/document/d/${reportStampName}/export?format=doc`
            }

    // const fileName = `https://docs.google.com/document/d/1j_MAzLEEyZgHBs16mF1RNhN73PEeQ-lc/edit?usp=sharing&ouid=106592907302576780100&rtpof=true&sd=true`

        getBinaryContentWithRedirectSupport(fileName, (error, content) => {
        let isError = false

        if (error) {
            throw 'error'
        }
        const zip2 = new JSZip();
        const finalDocxs = []
        objects.forEach(async object => {
            const oldReportToPrint = oldReportToPrints?.find(r => r.pupil === object.pupil)
            const Obj = prepareObj(object, userName, gradeId, dateHebrew, reportName, oldReportToPrint)
            try {
                const zip = new PizZip(content);

                const doc = new DocxTemplate(zip, {paragraphLoop: true, linebreaks: true, nullGetter});
                doc.setData(Obj);
                try {
                    doc.render();
                } catch (error) {
                    function replaceErrors(key, value) {
                        if (value instanceof Error) {
                            return Object.getOwnPropertyNames(value).reduce(function (
                                error,
                                key
                                ) {
                                    error[key] = value[key];
                                    return error;
                                },
                                {});
                        }
                        return value;
                    }

                    if (error.properties && error.properties.errors instanceof Array) {
                        const errorMessages = error.properties.errors
                            .map(function (error) {
                                return error.properties.explanation;
                            })
                            .join("\n");
                        // errorMessages is a humanly readable message looking like this :
                        // 'The tag beginning with "foobar" is unopened'
                    }
                    throw error;
                }
                const out = doc.getZip().generate({
                    type: "nodebuffer",
                    mimeType:
                        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                });
                finalDocxs.push(out)
                zip2.file(`${Obj.pupil}.docx`, out);
            } catch (e) {
                console.log( e)
                isError = true
                throw e
            }


        });
        if (isError === true){
            console.log("RUN ERROR")
            errorBlock()

            throw "error in for each"
        }
        if (oneFile) {
            var docx = new DocxMerger({}, finalDocxs);
            docx.save('blob', function (data) {
                saveAs(data, "output.docx");
            });
        } else {
            zip2.generateAsync({type: 'blob'}).then((content) => {
                saveAs(content, `${getGradeFullName(gradeId)}.zip`);
            });
        }

        // zip2.file(`13123`, docx);


    })
    } catch (e) {
        console.log("7777",e)
        throw e
    }
    if (isError){
        throw "error in for each"
    }
}
